<style>
.hello {
  width: 100%;
  height: 500px;
  margin-top: 20px;
}
</style>

<template>
  <div style="padding: 40px; background-color: #fff;">
    <div>
      <b
        ><h3>{{ title }}</h3></b
      >
    </div>
    <v-layout>
      <v-toolbar
        class="mt-10"
        style="box-shadow: none; background-color: #fff;"
      >
        <v-layout>
          <v-row>
            <v-col cols="12" md="3">
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Start Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>

                    <!-- <v-btn depressed>Clear</v-btn> -->
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="End Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                item-text="plant_name"
                item-value="plant_code"
                v-model="plant"
                :items="list_plant"
                label="Choose Plant"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <v-btn color="primary" depressed v-on:click="getData">
                  Search
                </v-btn>

                <v-btn
                  color="success"
                  class="ml-2"
                  depressed
                  dark
                  v-on:click="alldata()"
                >
                  Clear Filter
                </v-btn>

                <v-progress-circular
                  indeterminate
                  class="ml-3"
                  color="primary"
                  v-if="loading"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row>
        </v-layout>
      </v-toolbar>
    </v-layout>
    <br />

    <v-layout>
      <v-flex md12>
        <div>Requesition by Plant</div>
        <div class="hello" id="chartdiv"></div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex md12>
        <br /><br />
        <div>Requesition by Requester</div>
        <div class="hello" id="chartdiv2"></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"
import moment from "moment"

am4core.useTheme(am4themes_animated)

export default {
  methods: {
    getData() {
      var self = this
      var url = self.base_url + "material/dashboard/topRequesterPlant"
      var url2 = self.base_url + "material/dashboard/topRequesterUser"
      self.loading = true

      var data = {
        plant: self.plant,
        startdate: self.date,
        enddate: self.date2,
      }

      if (self.storage_role === "REQ") {
        data.requester = self.storage_user_id
      }

      self.axios.post(url, data).then(function(response) {
        self.chart_data1 = response.data
        self.chart()
        self.loading = false
      })

      self.axios
        .post(url2, {
          plant: self.plant,
          startdate: self.date,
          enddate: self.date2,
        })
        .then(function(response) {
          self.chart_data2 = response.data
          self.chart2()
          self.loading = false
        })
    },
    chart() {
      var self = this
      am4core.ready(function() {
        am4core.useTheme(am4themes_animated)
        var chart = am4core.create("chartdiv", am4charts.XYChart)

        chart.data = self.chart_data1

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        categoryAxis.dataFields.category = "plant_name"
        categoryAxis.renderer.grid.template.location = 0
        categoryAxis.renderer.minGridDistance = 30

        categoryAxis.renderer.labels.template.adapter.add("dy", function(
          dy,
          target
        ) {
          if (target.dataItem && target.dataItem.index & (2 == 2)) {
            return dy + 25
          }
          return dy
        })

        chart.yAxes.push(new am4charts.ValueAxis())

        var series = chart.series.push(new am4charts.ColumnSeries())
        series.dataFields.valueY = "total"
        series.dataFields.categoryX = "plant_name"
        series.name = "Total Item"
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]"
        series.columns.template.fillOpacity = 0.8

        var columnTemplate = series.columns.template
        columnTemplate.strokeWidth = 0
        columnTemplate.strokeOpacity = 1
      })
    },
    chart2() {
      var self = this
      am4core.ready(function() {
        am4core.useTheme(am4themes_animated)

        var chart = am4core.create("chartdiv2", am4charts.XYChart)
        chart.data = self.chart_data2
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        categoryAxis.dataFields.category = "name"
        categoryAxis.renderer.grid.template.location = 0
        categoryAxis.renderer.minGridDistance = 30
        categoryAxis.renderer.labels.template.rotation = 90

        categoryAxis.renderer.labels.template.adapter.add("dy", function(
          dy,
          target
        ) {
          if (target.dataItem && target.dataItem.index & (2 == 2)) {
            return dy + 25
          }
          return dy
        })

        chart.yAxes.push(new am4charts.ValueAxis())

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries())
        series.dataFields.valueY = "total"
        series.dataFields.categoryX = "name"
        series.name = "Total Item"
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]"
        series.columns.template.fillOpacity = 0.8

        var columnTemplate = series.columns.template
        columnTemplate.strokeWidth = 0
        columnTemplate.fill = "#03af70"
        columnTemplate.strokeOpacity = 1
      })
    },
    alldata() {
      var self = this

      self.date = ""
      self.date2 = ""
      self.plant = ""
      self.getData()
    },
    getDateMonth() {
      this.date = moment()
        .startOf("month")
        .format("YYYY-MM-DD")

      this.date2 = moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    },
    getPlant() {
      var self = this
      var url = self.base_url + "master/dropdown/attribute/plant/plant_code"
      self.axios.get(url).then(function(response) {
        self.list_plant = response.data
      })
    },
  },
  mounted() {
    if (
      this.storage_role != "CAT" &&
      this.storage_role != "ADM" &&
      this.storage_role != "APP1" &&
      this.storage_role != "REQ"
    ) {
      this.$router.push("/login")
    }

    // this.getDateMonth()
    this.getData()
    this.getPlant()
  },
  data() {
    return {
      name: "TopRequester",
      title: "Top Requester",
      chart_data1: [],
      chart_data2: [],
      date: "",
      date2: "",
      list_plant: [],
      plant: null,
      loading: false,

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
    }
  },
}
</script>
